import {put,takeLatest,call} from 'redux-saga/effects'
import * as superUserService from "../../../services/superUserService"
import {
    UPDATE_SUPERUSER,
    UPDATE_SUPERUSER_SUCCESS,
    UPDATE_SUPERUSER_ERROR
}
    from "../../actions/superuser"

function* updateSuperUserSaga(action) {
    try {
        const data=yield call(superUserService.UpdateSuperUser,action.payload)
        yield put({
            type: UPDATE_SUPERUSER_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: UPDATE_SUPERUSER_ERROR,error: error.data
        })
    }
}


export function* updateSuperUserSagaWatcher() {
    yield takeLatest(UPDATE_SUPERUSER,updateSuperUserSaga)
}